import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/new-product")({
  component: lazyRouteComponent(() => import("./-pages/admin.new-product")),
  head: () => ({
    meta: [
      { title: "صفحة منتج جديد — إدارة" },
      { name: "description", content: "بناء بلوكات صفحة /new-product." },
    ],
  }),
});
